import React, { useState } from 'react';
import Navbar from '../layout/Navbar';
import Footer from '../layout/Footer';
import VisualVibeTransformerExplainer from '../home/VisualVibeTransformerExplainer';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase';
import './PeopleAreFinishedPage.css';

const PeopleAreFinishedPage = ({ currentUser, onNavigateHome, onShowLoginPopup, onShowSignUp }) => {
  const [showVvtfExplainer, setShowVvtfExplainer] = useState(false);

  const goHome = () => {
    if (onNavigateHome) {
      onNavigateHome();
    } else {
      window.location.href = '/';
    }
  };

  const handleSignOut = async () => {
    try {
      await signOut(auth);
    } catch (err) {
      console.error('Error signing out:', err);
    }
  };

  return (
    <>
      <Navbar
        onShowLoginPopup={onShowLoginPopup}
        onShowSignUp={onShowSignUp}
        currentUser={currentUser}
        onSignOut={handleSignOut}
        onPostersClick={goHome}
        onYourRewardsClick={goHome}
        onMessagesClick={goHome}
        onLogoClick={goHome}
      />

      <main className="paf-page">
        <article className="paf-content">
          <h1 className="paf-title">
            PEOPLE ARE <span className="paf-title-star">F*</span>
          </h1>

          <p>
            An LLM just solved a math problem that no
            human could solve for 80+ years. No rational decision making system will keep
            humans around for long.
          </p>

          <p>Unless we show it what we’re really about.</p>

          <p>
            For the last 3 years, I’ve been moving to a new home every 2-3 months. What
            started as an attempt to escape a painful breakup and understand my own
            emotions, turned into a hobby or even a passion. I’ve stayed in 13 different
            neighborhoods across SF and NY, and I’ve shared home with 29 vastly different
            roommates. I’ve also gotten to know over 10,000 people that walked into our
            neighborhood gathering space COZMOS during our crazy run in NY.
          </p>

          <p>
            I have seen things. I hosted a shakuhachi performance in the East Village of
            New York. I kept up pagan fire through the summer solstice night in the
            Siberian village of Okunevo. I stayed at a place that had hosted a satanic
            ritual…
          </p>

          <p>
            I have seen people. I had a roommate I barely met cook my favorite soup just to
            cheer me up. Or a roommate pull a gun on me. Or one landlord say, completely
            unprompted, that I didn’t have to pay rent because they believed in my cause.
          </p>

          <p>
            People are <strong>Fun</strong>. They expand your idea of what’s possible.
          </p>

          <p>
            People are also <strong>Fragile</strong>. They need love.
          </p>

          <p>Too few people find love. It is hard to find.</p>

          <p>I met a lot of people jaded by Hinge and Tinder. A common cycle is:</p>

          <p className="paf-cycle">
            a heartbreak → seek affirmation on a dating app → lack of real connection →
            assume this is how the world is and people are <strong>Fake</strong>
          </p>

          <p className="paf-aside">
            (people do find love on Hinge and Tinder because love still prevails, but there
            has to be a better way.)
          </p>

          <p>
            The problem is that dating apps ‘page rank’ people on a set of common attributes.
            Match 10s with 10s and 1s with 1s. Then tweak the results a little for each
            user, but keep the backbone the same just like a search engine page. This
            reduces human complexity to a solvable formula. It’s gotten so streamlined now
            that there are dedicated apps and even consultants that “optimize” your dating
            app profile and improve your ranking.
          </p>

          <p>
            I am worried that LLM-based matching will destroy the remaining magic of human
            connection. LLMs map our world to words, but that simplifies emotion. It’s like
            asking Reddit and Quora to find you love. $50M+ has just been invested in
            LLM-powered matching startups in the last year.
          </p>

          <p>
            When two people meet in person, non-verbal cues inform 90% of our perception of
            each other. To understand emotion, we need a machine-learning model that embeds
            emotions directly rather than relying on language.
          </p>

          <p>
            At luv.wtf, we’re building the{' '}
            <button
              type="button"
              className="paf-vvtf-link"
              onClick={() => setShowVvtfExplainer(true)}
            >
              Visual Vibe Transformer (VVTF)
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="paf-vvtf-link-arrow"
                aria-hidden
              >
                <path d="M7 17 17 7M7 7h10v10" />
              </svg>
            </button>{' '}
            for that. Our goal is to preserve the emotional dimension of the world, the{' '}
            <strong>Fun</strong> part.
          </p>

          <p className="paf-closing">
            People are <strong>F🦊ed</strong>.
            <br />
            People are <strong>Forever</strong>.
            <br />
            Up to You.
          </p>

          <p className="paf-join">
            <button type="button" className="paf-join-button" onClick={goHome}>
              Join us
            </button>
          </p>

          <p className="paf-signoff">— Vlad</p>
        </article>
      </main>

      <Footer
        onShowSignUp={onShowSignUp}
        onSignOut={handleSignOut}
        currentUser={currentUser}
        onStartCollage={goHome}
        isPrelaunch
      />

      <VisualVibeTransformerExplainer
        open={showVvtfExplainer}
        onClose={() => setShowVvtfExplainer(false)}
        signedIn={Boolean(currentUser)}
        onSignUp={onShowSignUp}
      />
    </>
  );
};

export default PeopleAreFinishedPage;
